export class PeriodoAmbitoViewModel {
    constructor() {}

    public Id: number;
    public AmbitoNacional: boolean;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public PeriodoFechaInicio?: Date;
    public PeriodoFechaFin?: Date;
    public TPeriodoAmbitoCaCamCollection: PeriodoAmbitoCaCamViewModel[];
    public TPeriodoAmbitoProvinciaCamCollection: PeriodoAmbitoProvinciaCamViewModel[];
}

export class PeriodoAmbitoCaCamViewModel {
    public Id: number;
    public IdPeriodo: number;
    public IdCA: number;
    public DescripcionComunidad: string;
}

export class PeriodoAmbitoProvinciaCamViewModel {
    public Id: number;
    public IdPeriodo: number;
    public IdProvincia: number;
    public IdComunidad: number;
    public DescripcionProvincia: string;
}
